import { useQuery } from "@tanstack/react-query";
import { contractorApi } from "../api/contractorApi";
import { ContractorGraph } from "../contractorTypes";

export const useFetchGraph = () => {

    const { data, isFetching, isPending, isError, error, refetch } = useQuery({
        queryKey: ["contractor-graph"],
        queryFn: () => contractorApi.fetchGraph(),
    });

    return {
        data: data as ContractorGraph,
        isLoading: isFetching || isPending,
        isError,
        error,
        refetch,
    };

};
